import React from 'react';
import { motion } from 'framer-motion';
import { Zap, CheckCircle2 } from 'lucide-react';
const upsellFeatures = [{
  title: 'SECCIÓN 1 — El Traductor de Clínica',
  desc: "60 equivalencias técnicas exactas. De 'lo que viste en el living' a 'lo que el auditor necesita leer'.",
  examples: ["De 'se golpeó la cabeza' → 'Presentó conducta autolesiva con impacto en región cefálica'", "De 'no quiso hacer nada' → 'Presentó baja disposición con conductas de evitación activa'"],
  extra: '5 bloques clínicos completos: Conductas motoras, verbales, emocionales, sociales e intervenciones.'
}, {
  title: 'SECCIÓN 2 — Hojas de Ruta: Los Primeros 30 Días',
  desc: 'Semana a semana qué observar, qué registrar y qué trabajar en el primer mes de un caso nuevo. Para TEA, Psicosis, TDAH y Gerontes.',
  extra: 'Nunca más vas a llegar a una primera sesión sin saber qué hacer.'
}, {
  title: 'SECCIÓN 3 — Protocolo Legal de Cobro',
  desc: '3 modelos de cartas listos para enviar cuando no te pagan: Nota de Pronto Despacho, Carta de Reclamo a la Familia, Reclamo Administrativo por Rechazo.',
  extra: 'Una sola carta de reclamo redactada por un abogado cuesta más de $15.000. Acá las tenés las 3 listas para usar.'
}, {
  title: 'SECCIÓN 4 — Crisis Nivel 2',
  desc: 'Técnicas avanzadas que el Módulo 4 no cubre. Los 6 pasos de desescalada verbal para crisis de agresividad. Grounding de 5 sentidos para pánico. Protocolo de intervención en episodios disociativos.',
  extra: 'Lo que no está en ningún manual de formación de AT.'
}, {
  title: 'SECCIÓN 5 — El Vademécum del AT',
  desc: 'Los psicofármacos más comunes en tus pacientes. Qué efectos secundarios observar. Cuándo es urgente reportar al equipo. Cómo registrarlo en el informe sin invadir el rol médico.',
  extra: 'Antipsicóticos. Estabilizadores. Ansiolíticos. Todo lo que necesitás saber como AT sin ser médico.'
}];
export function UpsellSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-312">
      {/* Gold highlighted background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1a1608] via-[#2a220a] to-[#1a1608] -z-10" data-id="element-313" />
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 -z-10 mix-blend-overlay" data-id="element-314" />
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#d4af37] to-transparent" data-id="element-315" />
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#d4af37] to-transparent" data-id="element-316" />

      <div className="max-w-4xl mx-auto" data-id="element-317">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-318">
          <div className="inline-flex items-center justify-center p-3 bg-[#d4af37]/20 rounded-full mb-6 gold-glow" data-id="element-319">
            <Zap className="w-8 h-8 text-[#d4af37]" data-id="element-320" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-white font-heading mb-4 tracking-wider" data-id="element-321">
            ⚡ UN MOMENTO — ANTES DE CONFIRMAR TU COMPRA
          </h2>
          <p className="text-xl text-[#d4af37] font-medium" data-id="element-322">
            Agregá esto a tu pack y completá el sistema en un solo paso.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg text-[#e2e8f0] mb-16 text-center max-w-3xl mx-auto" data-id="element-323">
          <p data-id="element-324">El Método Elite AT resuelve tu documentación diaria.</p>
          <p data-id="element-325">Pero hay situaciones que necesitan un nivel más de profundidad.</p>

          <div className="space-y-4 my-8 text-left bg-[#0a1628]/50 p-6 md:p-8 rounded-2xl border border-[#d4af37]/30" data-id="element-326">
            <p className="italic" data-id="element-327">
              ¿Qué hacés cuando el paciente entra en crisis severa y quedás
              congelado/a?
            </p>
            <p className="italic" data-id="element-328">
              ¿Cómo describís en el informe lo que viste en el domicilio con el
              lenguaje exacto que impresiona al auditor?
            </p>
            <p className="italic" data-id="element-329">
              ¿Qué hacés cuando la Obra Social no paga y no sabés cómo reclamar
              sin perder la prestación?
            </p>
          </div>

          <p data-id="element-330">La mayoría de los AT no tiene respuesta para estas preguntas.</p>
          <p className="text-2xl text-white font-bold" data-id="element-331">Vos vas a tenerla.</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-[#0a1628] border-2 border-[#d4af37] rounded-3xl p-6 md:p-10 shadow-2xl gold-glow-strong" data-id="element-332">
          <div className="text-center mb-10 border-b border-[#d4af37]/20 pb-8" data-id="element-333">
            <span className="text-4xl mb-4 block" data-id="element-334">🏆</span>
            <h3 className="text-sm font-bold text-[#d4af37] tracking-widest mb-2" data-id="element-335">
              COMPLETÁ TU SISTEMA CON:
            </h3>
            <h4 className="text-3xl md:text-4xl font-bold text-white font-heading mb-4" data-id="element-336">
              EL CEREBRO CLÍNICO DEL AT
            </h4>
            <p className="text-xl text-[#e2e8f0]" data-id="element-337">
              Suplemento Elite de Intervención Avanzada
            </p>
            <p className="text-[#a0aec0] mt-2" data-id="element-338">
              53 páginas adicionales de herramientas clínicas y legales
            </p>
          </div>

          <div className="space-y-8" data-id="element-339">
            {upsellFeatures.map((feat, index) => <div key={index} className="flex gap-4" data-id="element-340">
                <CheckCircle2 className="w-6 h-6 text-[#d4af37] shrink-0 mt-1" data-id="element-341" />
                <div data-id="element-342">
                  <h5 className="text-lg font-bold text-white mb-2" data-id="element-343">
                    {feat.title}
                  </h5>
                  <p className="text-[#e2e8f0] mb-3" data-id="element-344">{feat.desc}</p>

                  {feat.examples && <div className="bg-[#0f1d36] p-4 rounded-lg mb-3 space-y-2 border border-[#1a2b4c]" data-id="element-345">
                      {feat.examples.map((ex, i) => <p key={i} className="text-sm text-[#a0aec0] italic" data-id="element-346">
                          {ex}
                        </p>)}
                    </div>}

                  <p className="text-[#d4af37] text-sm font-medium" data-id="element-347">
                    {feat.extra}
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}